import CollapseTransition from './src/collapse-transition';

CollapseTransition.install = function(Vue) {
  Vue.component(CollapseTransition.name, CollapseTransition);
};

export default CollapseTransition;




// WEBPACK FOOTER //
// ./src/components/collapse-transition/index.js